<template>
  <div>
    <el-dropdown>
      <span class="el-dropdown-link"> 更多<i class="el-icon-arrow-down el-icon--right"></i> </span>
      <el-dropdown-menu slot="dropdown">
        <div class="brand_list">
          <div class="brand_left_list">
            <ul>
              <li v-for="(item, index) in searchLetterList" :key="index">
                <div class="title">{{ item }}</div>
                <div class="brand_tab">
                  <span v-for="itemA in brandList[item]" :key="itemA.id" @click="chooseBrand(itemA.id)">{{ itemA.name }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  props: ['dataIdName', 'dataId'],
  data() {
    return {
      id: '',
      idName: '',
      searchLetterList: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
      brandList: {},
      brand: ''
    }
  },
  created() {
    this.idName = this.dataIdName
    this.id = this.dataId
    this.loadData()
  },
  methods: {
    listBrand(brandArr) {
      var temp = {}
      this.searchLetterList.forEach((itemA, index) => {
        temp[itemA] = []
        brandArr.forEach(item => {
          if (itemA === item.firstLetter) {
            temp[itemA].push(item)
          }
        })
      })
      return temp
    },
    async loadData() {
      const { data } = await this.$http.get('/erp4open_api/auction/brandList', {
        params: {
          companyId: 1
        }
      })
      if (data.success) {
        this.brandList = this.listBrand(data.data.list)
      }
    },
    chooseBrand(brandId) {
      this.$emit('chooseBrand', brandId)
    }
  }
}
</script>

<style lang="less" scoped>
.brand_list {
  width: 800px;
  height: 400px;
  overflow: auto;
  .brand_left_list {
    ul {
      display: flex;
      flex-direction: column;
      li {
        display: flex;
        .title {
          color: #f37420;
          width: 8%;
          padding-left: 10px;
          padding-top: 5px;
        }
        .brand_tab {
          display: flex;
          flex-wrap: wrap;
          width: 92%;
          span {
            padding: 5px 8px;
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
